import { Stack } from '@mui/material';
import {
  DatePicker,
  AdvancedFieldWrapperVertical as FieldWrapperVertical,
  useFormPermissions,
} from '@ui-framework/index';
import { forwardRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import RecurrenceOptionsPattern from './RecurrenceOptionsPattern';
import RecurrenceOptionsPatternWeekly from './RecurrenceOptionsPatternWeekly';
import RecurrenceOptionsPatternMonthly from './RecurrenceOptionsPatternMonthly';
import { MAX_WIDTH_HORZ_LAYOUT } from '../../../../utils/constants';
import RecurringOptionsEndDate from './RecurringOptionsEndDate';
import RecurrenceOptionsPatternYearly from './RecurrenceOptionsPatternYearly';
import TimeSlotsAvaibilitySelector from '../../../TimeSlotsAvaibilitySelector';

const RecurringOptions = forwardRef((props, ref) => {
  const { control, errors } = useFormContext();
  const { permissions } = useFormPermissions();
  const recurrenceFrequencyValue = useWatch({
    control,
    name: 'recurrenceFrequency',
  });

  return (
    <Stack spacing={2} ref={ref}>
      <FieldWrapperVertical
        horizontal
        labelMaxWidth={MAX_WIDTH_HORZ_LAYOUT}
        field={{
          name: 'startDate',
          label: {
            localeId: 'START_DATE',
            defaultMessage: 'Start Date',
          },
          required: true,
        }}
        errors={errors}>
        <DatePicker
          boxProps={{ sx: { maxWidth: '300px' } }}
          disablePast
          permission={permissions?.startDate}
          name="startDate"
        />
      </FieldWrapperVertical>
      <FieldWrapperVertical
        horizontal
        labelMaxWidth={MAX_WIDTH_HORZ_LAYOUT}
        field={{
          name: 'recurrenceFrequency',
          label: {
            localeId: 'RECURRENCE_PATTERN',
            defaultMessage: 'Recurrence pattern',
          },
          required: true,
        }}
        errors={errors}>
        <RecurrenceOptionsPattern
          recurrenceFrequencyValue={recurrenceFrequencyValue}
          name="recurrenceFrequency">
          {recurrenceFrequencyValue === 'WEEKLY' && (
            <RecurrenceOptionsPatternWeekly />
          )}
          {recurrenceFrequencyValue === 'MONTHLY' && (
            <RecurrenceOptionsPatternMonthly />
          )}
          {recurrenceFrequencyValue === 'YEARLY' && (
            <RecurrenceOptionsPatternYearly />
          )}
        </RecurrenceOptionsPattern>
      </FieldWrapperVertical>
      <FieldWrapperVertical
        horizontal
        labelMaxWidth={MAX_WIDTH_HORZ_LAYOUT}
        field={{
          name: 'recurrencePatternWeeklyEndDate',
          label: {
            localeId: 'END_DATE',
            defaultMessage: 'End Date',
          },
          required: true,
        }}
        errors={errors}>
        <RecurringOptionsEndDate />
      </FieldWrapperVertical>
      <FieldWrapperVertical
        horizontal
        labelMaxWidth={MAX_WIDTH_HORZ_LAYOUT}
        field={{
          name: 'slotAvailability',
          label: {
            localeId: 'TIME_SLOTS',
            defaultMessage: 'Time Slots',
          },
          required: true,
        }}
        errors={errors}>
        <TimeSlotsAvaibilitySelector
          permission={permissions.slotAvailability}
        />
      </FieldWrapperVertical>
    </Stack>
  );
});

export default RecurringOptions;
